import { Theme, useStyles } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import React, { ReactNode, useRef } from 'react'

import { loginImages, loginImagesPeriodoEleitoral } from './login-images'

interface InitialContainerProps {
  children: ReactNode
}

export function InitialContainer({ children }: Readonly<InitialContainerProps>) {
  const { PERIODO_ELEITORAL_ENABLED } = useFlags()
  const availableImages = PERIODO_ELEITORAL_ENABLED ? loginImagesPeriodoEleitoral : loginImages

  const imageIndex = useRef(Math.floor(Math.random() * availableImages.length))
  const selectedImage = availableImages[imageIndex.current % availableImages.length]

  const { classes } = useStyles(createStyles, selectedImage.path)

  return (
    <div className={classes.container}>
      <div className={classes.contentColumn}>{children}</div>
      <div className={classes.imageColumn}>
        <div className={classes.imageCaption}>{selectedImage.caption}</div>
      </div>
    </div>
  )
}

const createStyles = (theme: Theme, imagePath: string) => ({
  container: {
    display: 'flex',
    height: 'calc(100vh - 42px)', // desconta o tamanho da barra brasil
  },
  contentColumn: {
    background: theme.pallete.surface.main,
    minWidth: '400px',
    width: '22%',
    padding: '4rem 4rem 4rem 4rem',
    overflow: 'auto',
  },
  imageColumn: {
    background: `url(${imagePath}) no-repeat center center fixed`,
    backgroundSize: 'cover',
    width: '78%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  imageCaption: {
    opacity: 0.8,
    display: 'inline',
    background: '#f0f0f5',
    color: '#3a3a47',
    height: '36px',
    padding: '0.5rem 1rem',
    margin: '0.5rem 0.5rem',
  } as React.CSSProperties,
})
